import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ComingSoonModal from './ComingSoonModal';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-wrapper">
          {/* Logo */}
          <div className="footer-logo-section">
            <picture>
              <source srcSet="/TechGenieMascot.webp" type="image/webp" />
              <img src="/TechGenieMascot.png" alt="TeachGenie™.ai" className="footer-logo-img" />
            </picture>
            <h2 className="footer-logo-text">TeachGenie™.ai</h2>
          </div>

          <nav className="footer-nav" aria-label="Product">
            {/* ASSESSATHON link removed 2026-08-18 — page unrouted per sir's instruction */}
            <Link to="/#features">FEATURES</Link>
            <Link to="/#packages">PRICING</Link>
            <Link to="/#how-it-works">HOW IT WORKS</Link>

            {/* TEAM link removed 2026-08-20 — page unrouted per sir's instruction */}
            <Link to="/learn-more">ABOUT</Link>
            <Link to="/policies">POLICIES</Link>
            <Link to="/login">LOGIN</Link>
          </nav>

          {/* Company & legal — a SECOND row rather than six more items in the
              row above. The primary nav is already six links and collapses to a
              vertical column at 480px; eleven items in one list would have been
              a ~440px stack on a phone. Splitting also matches how these read:
              product links above, company/legal below. */}
          <nav className="footer-legal-nav" aria-label="Company and legal">
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/sitemap">Sitemap</Link>
          </nav>

          <div className="footer-copyright">
            <div className="copyright-line">© {currentYear} YOM Private Limited. All Rights Reserved. TeachGenie™.ai</div>
            <div className="copyright-subline">Built and managed by Vertos of LPU</div>
          </div>

          {/* Credits */}
          <div className="footer-credits">
            <span className="credit-item">
              <span className="credit-label">Ideator:</span>
              <span className="credit-name">
                <a href="https://www.linkedin.com/in/loviraj">Lovi Raj Gupta</a>
              </span>
            </span>
            <span className="divider">•</span>
            <span className="credit-item">
              <span className="credit-label">Founding Team:</span>
              <span className="credit-name">
                <a href="https://www.linkedin.com/in/dama-sriram/">Dama Sri Ram</a>, <a href="https://www.linkedin.com/in/prajithaa-parani/">Prajithaa Parani</a>, Golu Kumar & Medha Jha
              </span>
            </span>
            <span className="divider">•</span>
            <span className="credit-item">
              <a href="mailto:info@teachgenie.ai" className="credit-email">info@teachgenie.ai</a>
            </span>
          </div>

          {/* Patent Info */}
          {/*<div className="footer-patent" style={{ fontSize: '0.7em', marginTop: '10px', opacity: 0.8 }}>
            Patent Pending. Patent ID: IN202611003783  - YOM Private Limited
          </div>*/}

          {/* Short Disclaimer */}
          <div className="footer-disclaimer" style={{
            fontSize: '0.65em',
            marginTop: '15px',
            opacity: 0.7,
            maxWidth: '800px',
            margin: '15px auto 0',
            lineHeight: '1.4',
            textAlign: 'center'
          }}>
            TeachGenie™.ai is an AI-assisted learning tool for academic enrichment. Outputs are AI-generated and may be inaccurate, incomplete, or outdated. Verify critical information independently and comply with academic policies and applicable laws, including copyright. TeachGenie™.ai may not generate results in some cases and may generate incorrect results.
          </div>
        </div>
      </footer>

      {/* Coming Soon Modal */}
      <ComingSoonModal
        isOpen={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        featureName="Dashboard"
      />
    </>
  );
};

export default Footer;
